import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useState } from 'react';
import { toast } from 'react-toastify';
import {
	createPaymentsReceived,
	updatePaymentsReceived,
} from '../../../../../services/payments_received';
import ExcessPaymentModal from '../components/excessPaymentModal';
import Modal from '../../../../../component/modal/Modal';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../../../utils/controller';

const CreatePaymentReceivedHeader = ({
	error,
	setError,
	tableError,
	setTableError,
	paymentReceived,
	paymentReceivedTable,
	totalAmount,
	calculateTotalExcessPayment,
}) => {
	const [isExcessPaymentModalOpen, setIsExcessPaymentModalOpen] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState(false);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isPaymentReceivedAutoSave, setIsPaymentReceivedAutoSave] = useState(false);

	const checkValidation = (status) => {
		let newError = { ...error };
		let newTableError = [...tableError];
		if (
			!paymentReceived.customer_id ||
			paymentReceived.customer_id === '' ||
			paymentReceived.customer_id === undefined
		) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!paymentReceived.payment_receive_number ||
			paymentReceived.payment_receive_number === '' ||
			paymentReceived.payment_receive_number === undefined
		) {
			newError.payment_receive_number = 'Please enter payment receive number in the field';
		} else {
			delete newError.payment_receive_number;
		}

		if (
			!paymentReceived.date ||
			paymentReceived.date === '' ||
			paymentReceived.date === undefined ||
			(paymentReceived.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter payment date in the field';
		} else {
			delete newError.date;
		}

		if (
			!paymentReceived.payment_method ||
			paymentReceived.payment_method === '' ||
			paymentReceived.payment_method === undefined
		) {
			newError.payment_method = 'Please select a valid payment method from the list.';
		} else {
			delete newError.payment_method;
		}

		if (
			!paymentReceived.received_payment_amount ||
			paymentReceived.received_payment_amount === '' ||
			paymentReceived.received_payment_amount === undefined ||
			(paymentReceived.received_payment_amount !== '' && newError.received_payment_amount)
		) {
			newError.received_payment_amount = 'Please enter payment receive amount in the field';
		} else {
			delete newError.received_payment_amount;
		}

		if (
			Object.keys(newError).length > 0 ||
			newTableError.length > 0 ||
			calculateTotalExcessPayment() < 0
		) {
			setError(newError);
			setTableError(newTableError);
			return true;
		} else {
			return false;
		}
	};

	const handleSubmitPaymentReceived = async (status, isCreditNote = false) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			if (calculateTotalExcessPayment() < 0) {
				toast.error('Payment Amount should not greater than amount received.');
			} else {
				toast.error('Please fill all mandatory fields before saving');
			}
		} else {
			try {
				setLoading(true);
				const body = {
					customer_id: paymentReceived?.customer_id,
					payment_receive_number: paymentReceived?.payment_receive_number,
					date: paymentReceived?.date,
					payment_mode_id: paymentReceived?.payment_method,
					received_payment_amount: paymentReceived?.received_payment_amount,
					deposit_to_id: 1,
					notes: paymentReceived?.notes,
					status: status,
					used_payment_amount: totalAmount().toFixed(2),
					excess_payment_amount: calculateTotalExcessPayment().toFixed(2),
					sales_payment_receives_invoices: paymentReceivedTable,
				};
				if (id) {
					var res = await updatePaymentsReceived(id, body);
					if (res?.success) {
						toast.success('Payment received updated Successfully');
						navigate(`/user/${suburl}/payments-received`);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				} else {
					const res = await createPaymentsReceived(body);
					if (res?.success) {
						toast.success('Payment Received Created Successfully');
						setIsLocationBlocker(false);
						setIsPaymentReceivedAutoSave(false);
						setTimeout(() => {
							navigate(`/user/${suburl}/payments-received`);
						}, 300);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsPaymentReceivedAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div className="product-pg-header add-product header-position-sticky">
			<p>
				{id ? 'Update ' : 'Create New '}
				Payments Received
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button={id ? 'Update' : 'Save'}
					loader={loading}
					disabled={
						loading ||
						(id
							? !hasPermission('sales.payments_received.edit', user?.role?.role_permissions)
							: !hasPermission('sales.payments_received.create', user?.role?.role_permissions))
					}
					onClick={() => {
						if (calculateTotalExcessPayment().toFixed(2) > 0 && !id) {
							setIsPaymentReceivedAutoSave(false);
							setIsExcessPaymentModalOpen(true);
						} else {
							setIsPaymentReceivedAutoSave(false);
							handleSubmitPaymentReceived(3, false);
						}
					}}
				/>
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => navigate(`/user/${suburl}/payments-received`)}
				/>
			</div>
			{isExcessPaymentModalOpen && (
				<ExcessPaymentModal
					isModalOpen={isExcessPaymentModalOpen}
					setIsModelOpen={setIsExcessPaymentModalOpen}
					handleCreditNote={() => handleSubmitPaymentReceived(2, true)}
					handlePaymentReceived={() => handleSubmitPaymentReceived(1, false)}
					handleLater={() => handleSubmitPaymentReceived(0, false)}
					excessAmount={calculateTotalExcessPayment().toFixed(2)}
				/>
			)}
			{isPaymentReceivedAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Payment Received Auto Save"
					isOpen={isPaymentReceivedAutoSave}
					onClose={() => {
						setIsPaymentReceivedAutoSave(false);
					}}
					cancelButton={() => {
						setIsPaymentReceivedAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsPaymentReceivedAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>

						<Button
							type="button"
							button="Save and Continue"
							disabled={
								!hasPermission('sales.payments_received.create', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsPaymentReceivedAutoSave(false);
								handleSubmitPaymentReceived(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreatePaymentReceivedHeader;
